import React from 'react';
import PropTypes from 'prop-types';
import Logger from '../../../../../../common/logger';
import { CMB_MODE } from '../../types';
import './CMBSummary.scss';

let countdownTimeout = null;

class CMBSummary extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countdownRemaining: this.props.cmbImmediateCountdown
        };
    }

    componentDidMount() {
        if (this.props.cmbMode === CMB_MODE.DELAYED) {
            this.countdown(this.props.cmbImmediateCountdown, null, () => {
                this.props.events.close();
            });
        } else {
            this.countdown(
                this.props.cmbImmediateCountdown,
                remaining => {
                    this.setState({
                        countdownRemaining: remaining
                    });
                },
                () => {
                    this.props.events.close();
                }
            );
        }
    }

    componentWillUnmount() {
        clearTimeout(countdownTimeout);
    }

    countdown(timeout, tickCallback, doneCallback) {
        Logger.log('Countdown: ' + this.state.countdownRemaining);
        const endtime = new Date(Date.now() + timeout * 1000);
        let lasttime = 0;

        if (typeof tickCallback !== 'function' && typeof doneCallback !== 'function') {
            return;
        }
        if (timeout === 0) {
            if (typeof doneCallback === 'function') doneCallback();
        }

        const processFunc = function() {
            const now = new Date();
            let lefttime = Math.ceil((endtime.getTime() - now.getTime()) / 1000);

            if (lefttime != lasttime && lefttime > 0) {
                if (typeof tickCallback === 'function') {
                    tickCallback(lefttime);
                }
            }

            if (lefttime <= 0) {
                if (typeof doneCallback === 'function') {
                    doneCallback();
                }
            } else {
                lasttime = lefttime;
                countdownTimeout = setTimeout(processFunc, 100);
            }
        };

        processFunc();
    }

    render() {
        const { cmbMode, cmbDelayedIntervalDay, cmbDelayedIntervalHour } = this.props;

        const cmbImmediate = (
            <div className="immediate">
                <p>Oczekiwanie na rozmowę z konsultantem. Oddzwonimy do Ciebie za:</p>
                <p className="time">{this.state.countdownRemaining} sekund</p>
            </div>
        );
        
        const cmbDelayed = (
            <div className="delayed">
                <p>Oddzwonimy do Ciebie:</p>
                <p className="time">
                    {cmbDelayedIntervalDay} {cmbDelayedIntervalHour}
                </p>
            </div>
        );

        return (
            <div className="cmb-summary">
                <h1>Dziękujemy!</h1>
                <div className="cmb-summary--info">
                    {cmbMode === CMB_MODE.DELAYED ? cmbDelayed : cmbImmediate}
                </div>
            </div>
        );
    }
}

CMBSummary.defaultProps = {
    cmbImmediateCountdown: 10
};

CMBSummary.propTypes = {
    cmbImmediateCountdown: PropTypes.number,
    cmbMode: PropTypes.string.isRequired,
    cmbDelayedIntervalDay: PropTypes.string,
    cmbDelayedIntervalHour: PropTypes.string,
    events: PropTypes.object.isRequired
};

export default CMBSummary;
